import { render, staticRenderFns } from "./applicantLanguage.vue?vue&type=template&id=9fbc259e&scoped=true"
import script from "./applicantLanguage.vue?vue&type=script&lang=js"
export * from "./applicantLanguage.vue?vue&type=script&lang=js"
import style0 from "./applicantLanguage.vue?vue&type=style&index=0&id=9fbc259e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fbc259e",
  null
  
)

export default component.exports